import { withRBAC } from "../rbac";
import type { Sale } from "../types";
import { SalesCreate } from "./SalesCreate";
import { SalesEdit } from "./SalesEdit";
import { SalesList } from "./SalesList";
import { SalesShow } from "./SalesShow";

export { AutoInvoicingPage } from "./auto-invoice/AutoInvoicingPage";
export { CustomerAgingPage } from "./aging/CustomerAgingPage";
export { CreditLimitsPage } from "./credit-limit/CreditLimitsPage";
export { PDCTrackingPage } from "./pdc-tracking/PDCTrackingPage";
export { CreditNotesPage } from "./credit-notes/CreditNotesPage";
export { ReceiptMatchingPage } from "./receipt-matching/ReceiptMatchingPage";
export { UserRolesPage } from "./UserRolesPage";

export default {
  list: withRBAC(SalesList, "manage_users"),
  create: withRBAC(SalesCreate, "manage_users"),
  edit: withRBAC(SalesEdit, "manage_users"),
  show: withRBAC(SalesShow, "manage_users"),
  recordRepresentation: (record: Sale) =>
    `${record.first_name} ${record.last_name}`,
};
